export const PrivacyPDFs = {
  "ar": "26-27_EVENT_HUB_Privacy_Policy_AR-SA.pdf",
  "de": "26-27_EVENT_HUB_Privacy_Policy_DE-DE.pdf",
  "es": "26-27_EVENT_HUB_Privacy_Policy_ES-MX.pdf",
  "en": "26-27_EVENT_HUB_Privacy_Policy_English.pdf",
  "fr": "26-27_EVENT_HUB_Privacy_Policy_FR-FR.pdf",
  "he": "26-27_EVENT_HUB_Privacy_Policy_HE-IL.pdf",
  "ja": "26-27_EVENT_HUB_Privacy_Policy_JA-JP.pdf",
  "nl": "26-27_EVENT_HUB_Privacy_Policy_NL-NL.pdf",
  "pt": "26-27_EVENT_HUB_Privacy_Policy_PT-BR.pdf",
  "tr": "26-27_EVENT_HUB_Privacy_Policy_TR-TR.pdf",
}

export const TermsPDFs = {
  "ar": "26-27_EVENT_HUB_Terms_of_Use_AR-SA.pdf",
  "de": "26-27_EVENT_HUB_Terms_of_Use_DE-DE.pdf",
  "es": "26-27_EVENT_HUB_Terms_of_Use_ES-MX.pdf",
  "en": "26-27_EVENT_HUB_Terms_of_Use_English.pdf",
  "fr": "26-27_EVENT_HUB_Terms_of_Use_FR-FR.pdf",
  "he": "26-27_EVENT_HUB_Terms_of_Use_HE-IL.pdf",
  "ja": "26-27_EVENT_HUB_Terms_of_Use_JA-JP.pdf",
  "nl": "26-27_EVENT_HUB_Terms_of_Use_NL-NL.pdf",
  "pt": "26-27_EVENT_HUB_Terms_of_Use_PT-BR.pdf",
  "tr": "26-27_EVENT_HUB_Terms_of_Use_TR-TR.pdf",
}

export default {PrivacyPDFs, TermsPDFs};
